import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import { Select } from "../Form";
export const NO_TEAM = "none";
const SelectTeam = (props)=>{
    const { value , teams , onChange  } = props;
    const options = useMemo(()=>[
            {
                label: "None",
                value: NO_TEAM
            },
            ...teams
        ], [
        teams
    ]);
    return /*#__PURE__*/ _jsx(Select, {
        label: "Workspace",
        value: value,
        options: options,
        onChange: onChange
    });
};
export default SelectTeam;
